<template>
  <div class="wrapper">
    <nav>
      <router-link to="/" class="title">
        viz.photos - image data visualized
      </router-link>
      <input id="burger" type="checkbox">
      <label for="burger">
        <span />
        <span />
        <span />
      </label>
      <div class="nav">
        <ul>
          <li>
            <router-link to="/">
              Overview
            </router-link>
            <img v-if="$root.currentMenuItem=='/'" class="wait" src="/assets/images/AppleLoading.gif" width="20px" height="20px">
          </li>
          <li>
            <router-link to="/color-canvas">
              By Color 
            </router-link>
            <img v-if="$root.currentMenuItem=='/color-canvas'" class="wait" src="/assets/images/AppleLoading.gif" width="20px" height="20px">
          </li>
          
          <li>
            <router-link to="/camera">
              By Camera
            </router-link>
            <img v-if="$root.currentMenuItem=='/camera'" class="wait" src="/assets/images/AppleLoading.gif" width="20px" height="20px">
          </li>
          <li>
            <router-link to="/tag">
              By Tags
            </router-link>
            <img v-if="$root.currentMenuItem=='/tag'" class="wait" src="/assets/images/AppleLoading.gif" width="20px" height="20px">
          </li>
        </ul>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script>
export default {
    name: "Navigation"
}
</script>

<style scoped lang="scss">
$blackColor: #020304;
$menuBackColor: #749099;

body {
  nav {
    text-align: center;
    margin: 0 auto;

    .title {
      position: fixed;
      top: 18px;
      left: 42px;
      // transform: translate(-50%, 0);
      color: black;
      font-size: 14px;
      padding: 5px 10px;
      // border: 1px solid red;
      cursor: pointer;
      z-index: 10;
    }

     .wait {
        margin: 0 0 -3px 0;
        display: inline;
        opacity: 0.5;
      }
  }

  input + label {
    position: fixed;
    top: 30px;
    right: 40px;
    height: 20px;
    width: 15px;
    z-index: 5;
    span {
      position: absolute;
      width: 100%;
      height: 2px;
      top: 50%;
      margin-top: -1px;
      left: 0;
      display: block;
      background: $blackColor;
      transition: 0.5s;
    }
    span:first-child {
      top: 3px;
    }
    span:last-child {
      top: 16px;
    }
  }
  label:hover {
    cursor: pointer;
  }
  #burger {
    opacity: 0;
  }
  input:checked + label {
    span {
      opacity: 0;
      top: 50%;
    }
    span:first-child {
      opacity: 1;
      transform: rotate(405deg);
    }
    span:last-child {
      opacity: 1;
      transform: rotate(-405deg);
    }
  }
  input ~ .nav {
    background: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    z-index: 3;
    transition: 0.5s;
    // transition-delay: 0.5s;
    overflow: hidden;
    > ul {
      text-align: center;
      position: absolute;
      top: 35%;
      left: 20%;
      right: 20%;
      > li {
        display: none;
        > a {
          text-decoration: none;
          text-transform: uppercase;
          color: $blackColor;
          font-weight: 700;
          // display: block;
          display: inline-block;
          padding: 30px 10px 30px;
        }
        > a.router-link-exact-active,
        a.router-link-exact-active:hover {
          color: #ccc;
          cursor: default;
          opacity: 0.5;
        }
      }
    }
  }
  input:checked ~ .nav {
    height: 100%;
    background: $menuBackColor;
    > ul {
      > li {
        display: block;
      }
    }
  }
}
</style>
    

